import React, { useContext } from 'react'
import { List } from './List'
import { Accordions } from './Accordions'
import { Button } from './Button'
import { useTranslation } from 'utils/useTranslation'

export function ProductCardBig({ innerRef, accessory, isInCart, onAddToCartClick, context }) {
  const {
    order
  } = useContext(context)

  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  const paymentType = order.paymentType ?? 'cash'

  return (
    <div className='mtt-product-card-big' ref={innerRef}>
      <div className='mtt-product-card-big__title-wrapper'>
        <div className='mtt-product-card-big__title'>
          <h3 className='mtt-title'>{accessory.title}</h3>
          <div className='mtt-terms'>{accessory.short_models_name.join(', ')}</div>
        </div>

        <div className='mtt-product-card-big__price'>
          <div className='mtt-price'>{paymentType === 'cash' ? accessory.price.formatted : accessory.price_leasing.formatted}</div>
          <div className='mtt-tagline'>{accessoryStrings.incl_vat}</div>
        </div>
      </div>

      <div className='mtt-product-card-big__content-wrapper'>
        <div className='mtt-product-card-big__image-wrapper'>
          <img src={accessory.image} alt='' />
        </div>

        <div className='mtt-product-card-big__text-wrapper'>
          <h3 className='mtt-title'>{accessory.title}</h3>
          <div className='mtt-excerpt wysiwyg' dangerouslySetInnerHTML={{ __html: accessory.description }} />

          <div className='list-title'>{accessory.features_title}</div>
          <List items={accessory.features} showAll />
          <div className='mtt-label' dangerouslySetInnerHTML={{ __html: accessory.obligation_text }} />
          <Button
            classes='primary'
            text={isInCart ? accessoryStrings.remove_from_cart : accessoryStrings.add_to_cart}
            onClick={onAddToCartClick}
          />
          <Accordions specifications={accessory.specifications} fits={accessory.fits} />
        </div>
      </div>
    </div>
  )
}
